export default "__VITE_ASSET__D_tI2W6Q__"